<div [ngClass]="{'vertical-layout':testViewVerticalLayout}">
  <gen-dynamic-form class="info-dynamic-form"
                    [formName]="getFormId()"
                    [formItemFullWidth]="widgetConfigPayload?.formItemFullWidth"
                    [formData]="data"
                    [disabled]="isFormDisabled"
                    [additionalSearchValues]="additionalSearchValues"
                    (formChange)="formChanged($event)"
                    (itemTouched)="onItemTouched($event)"
                    [disabledOptions]="disabledOptions"
                    id="off-pathway"></gen-dynamic-form>
</div>
